import {
  DocumentEditData,
  EditDocumentUseCase,
} from 'shared/domain/document/editDocument';
import {
  HttpRequestModelType,
  HttpRequestStatus,
  __HttpRequestModel__,
} from 'shared/domain/httpRequest/httpRequestModel';
import { broadcastUpdatedDocument } from 'serviceWorker/broadcasts/documents';
import { updateOne as editDocument, type DocumentChanges } from 'serviceWorker/db/documents';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { get as getCurrentProject } from 'serviceWorker/db/selectedProject';
import { Identificable } from 'shared/types/commonView';
import { isDefinedValue } from 'shared/utils/value';

// exported for tests, do we need them thou?
export class DocumentEditor implements EditDocumentUseCase {
  constructor(
    private editDocument: (
      localId: number,
      data: DocumentChanges
    ) => Promise<any>,
    private addRequest: (request: __HttpRequestModel__) => Promise<any>,
    private getCurrentProject: () => Promise<Identificable | undefined>,
    private broadcastDocumentUpdated: (localId: number) => void
  ) {}
  async execute(
    localId: number,
    editObject: DocumentEditData
  ): Promise<void> {
    await this.editDocument(localId, this.createChangesObject(editObject));
    this.broadcastDocumentUpdated(localId);
    const isDescriptionChanged = isDefinedValue(editObject.description);
    const isImageRotationChanged = isDefinedValue(editObject.imageRotation);
    const isChanged = isDescriptionChanged || isImageRotationChanged;

    if (isChanged) {
      const descriptionObject = editObject.description
        ? { description: editObject.description }
        : {};
      const imageRotationObject =
        isDefinedValue(editObject.imageRotation)
        ? { imageRotation: editObject.imageRotation }
        : {};
      const changes = { ...descriptionObject, ...imageRotationObject };
      const currentProject = await this.getCurrentProject();
      await this.addRequest({
        createdAt: Date.now(),
        entityType: HttpRequestModelType.document,
        data: {
          localId,
          projectId: currentProject?._id,
          changes,
        },
        method: 'PUT',
        status: HttpRequestStatus.NEW,
      });
    }
  }

  private createChangesObject(
    editObject: DocumentEditData
  ): DocumentChanges {
    // TODO: PT-4149 TYPESAFETY
    // const keys: (keyof Required<DocumentEditData>)[] = [
    //   'localId',
    //   'description',
    //   'clearLocalData',
    //   'drawingUploadStatus',
    //   'deleted',
    //   'syncStatus',
    //   'drawingSyncStatus',
    // ];

    const descriptionObject = editObject.description
      ? { description: editObject.description }
      : {};
    const deletedObject = editObject.deleted
      ? { deleted: editObject.deleted }
      : {};
    const localDataObject = editObject.clearLocalData
      ? { localData: undefined }
      : {};
    const drawingUploadStatusObject = editObject.drawingUploadStatus
      ? { 'data.drawnUploadStatus': editObject.drawingUploadStatus }
      : {};
    const syncStatus = editObject.syncStatus
      ? { syncStatus: editObject.syncStatus }
      : {};
    const drawingSyncStatus = editObject.drawingSyncStatus
      ? { drawingSyncStatus: editObject.drawingSyncStatus }
      : {};

    const imageRotationObject =
      isDefinedValue(editObject.imageRotation)
      ? { imageRotation: editObject.imageRotation }
      : {};

    return {
      ...descriptionObject,
      ...localDataObject,
      ...deletedObject,
      ...drawingUploadStatusObject,
      ...syncStatus,
      ...drawingSyncStatus,
      ...imageRotationObject,
    };
  }
}

const documentEditor = new DocumentEditor(
  editDocument,
  addRequest,
  getCurrentProject,
  broadcastUpdatedDocument
);

export default documentEditor;
